import React from 'react';
import CarinaAvatar, { AvatarProps } from '@cvent/carina/components/Avatar/Avatar';
import { ThemeWithPalette } from '@hooks/useTheme';
import BlockAvatar from '@cvent/blocks/components/BlockAvatar';
import { ThemeWithBlockStack } from '@cvent/blocks/utils/types';
import useTheme from '@cvent/carina/components/ThemeProvider/useTheme';
import objectHasProperty from '@tools/objectHasProperty';
import { getImageUrlWithResizing } from '@tools/getImageUrlWithResizing';

/**
 * Carina Avatar component but with background color overwritten to use theme primary color
 * Use this Avatar component to automatically resize the image to a common and smaller size
 * It is recommended to use 'Universal-AvatarName' phrase key for the name sent in Avatar props
 */
export function Avatar(props: AvatarProps): JSX.Element {
  const { onKeyPress, image } = props;
  const theme = useTheme() as ThemeWithBlockStack | ThemeWithPalette;

  let avatarImage = image;
  if (typeof image === 'string') {
    avatarImage = getImageUrlWithResizing(image);
  }

  let avatar: JSX.Element;
  if (objectHasProperty(theme, 'block')) {
    // Component is rendered in Blocks theme context
    avatar = <BlockAvatar {...props} image={avatarImage} />;
  } else {
    const { palette, backgroundColor } = theme;
    avatar = (
      <CarinaAvatar
        backgroundColorOverride={palette?.primary?.seedColor}
        borderColorOverride={backgroundColor.interactive.fill.base}
        {...props}
        image={avatarImage}
      />
    );
  }

  return (
    // HUB-100959
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span className="notranslate" onKeyPress={onKeyPress}>
      {avatar}
    </span>
  );
}

export default Avatar;
